import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SongCard } from '../components/SongCard';
import { highlightSongs } from '../data/songs';

export function renderMusicsPage(): string {
  const songCardsHtml = highlightSongs.map(s => SongCard(s)).join('');

  return /*html*/`
    ${Header()}
    
    <main class="fade-in">
      <!-- Musics Hero Header -->
      <section style="position: relative; padding: 5rem 0 4rem; overflow: hidden; background: radial-gradient(circle at 50% 20%, rgba(168, 85, 247, 0.15) 0%, rgba(7, 8, 13, 0.95) 75%); border-bottom: 1px solid rgba(168, 85, 247, 0.2);">
        <div style="position: absolute; inset: 0; opacity: 0.18; pointer-events: none;">
          <img src="/images/brand/atomix-music-banner.jpg" alt="AtomixMusics Studio" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        
        <div class="container" style="position: relative; z-index: 1; text-align: center; max-width: 850px;">
          <div class="badge badge-purple" style="margin-bottom: 1rem;">
            <sl-icon name="music-note-beamed"></sl-icon>
            <span>AtomixMusics Division</span>
          </div>
          <h1 style="font-size: clamp(2.2rem, 5vw, 3.5rem); margin-bottom: 1.25rem;">
            Generative AI Musics & <span class="text-gradient-purple">Audio Pipelines</span>
          </h1>
          <p style="font-size: 1.15rem; color: #cbd5e1; line-height: 1.6; margin-bottom: 2rem;">
            Inspired by Suno and state-of-the-art diffusion models, AtomixMusics develops custom AI pipelines, lyric-to-track workflows, and production-ready music tools across Pop, Rap, Indie, and Synthwave genres.
          </p>

          <div style="display: flex; justify-content: center; gap: 1rem; flex-wrap: wrap;">
            <a href="https://youtube.com/@atomixchannel" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);">
              <sl-icon name="youtube"></sl-icon>
              <span>YouTube Channel (@atomixchannel)</span>
            </a>
            <a href="https://open.spotify.com/artist/atomixmusic" target="_blank" rel="noopener noreferrer" class="btn-ghost">
              <sl-icon name="spotify"></sl-icon>
              <span>Spotify Artist Page</span>
            </a>
          </div>
        </div>
      </section>

      <!-- Pipeline & Tooling Showcase -->
      <section class="container" style="padding: 4.5rem 1.5rem 2rem;">
        <div class="grid grid-3" style="gap: 1.5rem;">
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #a855f7;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">⚡</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Suno-Inspired Pipeline</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Combining latent diffusion transformers and semantic token conditioning to sketch harmonies, vocals, and intricate rhythms in seconds.
            </p>
          </div>
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #00f2fe;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">🎛️</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Algorithmic Mixing</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Neural stem separation, multiband dynamic equalization, and AI mastering designed to deliver radio-ready spatial clarity.
            </p>
          </div>
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #06d6a0;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">🎮</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Interactive Game OSTs</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Seamless dynamic audio stems integrated directly into AtomixGame titles (Atom3D/AtomGdx) for reactive adaptive gameplay soundtracks.
            </p>
          </div>
        </div>
      </section>

      <!-- Music Tracks Catalog -->
      <section class="container" style="padding: 3.5rem 1.5rem 5rem;">
        <div class="section-header" style="text-align: left; margin-bottom: 2.5rem;">
          <span class="badge badge-purple" style="margin-bottom: 0.5rem;">Discography & Releases</span>
          <h2 style="font-size: 2rem;">Featured AI Compositions & Remixes</h2>
          <p style="margin: 0;">Stream original tracks and remixes produced through our neural generative audio pipeline.</p>
        </div>
        <div class="grid grid-3">
          ${songCardsHtml}
        </div>
      </section>

    </main>

    ${Footer()}
  `;
}
